import * as ActionTypes from "./ActionTypes";

export const setUserSkills = (skills) => {
  return {
    type: ActionTypes.SET_USER_SKILLS_AD,
    skills,
  };
};
